/**
 * GA4 Event Constants for Promotions Funnel Tracking
 * ===================================================
 * 
 * Naming Convention:
 *   - All event names use lowercase with underscores (snake_case)
 *   - Prefixed with "promo_" for namespace isolation in GA4
 *   - Descriptive, action-oriented names for clear funnel identification
 * 
 * Funnel Order (Landing Page → Thank You):
 *   1. promo_landing_page_view
 *   2. promo_user_login
 *   3. promo_front_door_form_view
 *   4. promo_front_door_form_submit
 *   5. promo_offer_tcs_view
 *   6. promo_registration_page_view
 *   7. promo_registration_submit
 *   8. promo_submission_created       ← finalize endpoint
 *   9. promo_thank_you_page_view
 *  10. promo_tracker_details_click    ← Pizza Tracker "Details" button
 * 
 * Each event pushes to window.dataLayer which GTM forwards to GA4.
 * No PII (phone numbers, names, emails) is ever included in event parameters.
 */

// ─── Funnel Step Events ─────────────────────────────────────────────────────

/** Step 1 – User lands on the promotions home / landing page */
export const PROMO_LANDING_PAGE_VIEW = "promo_landing_page_view";

/** Step 2 – User completes login (OAuth / TFB / id_token) */
export const PROMO_USER_LOGIN = "promo_user_login";

/** Step 3a – Front-door form page is displayed */
export const PROMO_FRONT_DOOR_FORM_VIEW = "promo_front_door_form_view";

/** Step 3b – User submits the front-door form (phone selection + continue) */
export const PROMO_FRONT_DOOR_FORM_SUBMIT = "promo_front_door_form_submit";

/** Step 4 – Offer Terms & Conditions page is displayed */
export const PROMO_OFFER_TCS_VIEW = "promo_offer_tcs_view";

/** Step 5a – Registration page is displayed */
export const PROMO_REGISTRATION_PAGE_VIEW = "promo_registration_page_view";

/** Step 5b – User submits the registration form */
export const PROMO_REGISTRATION_SUBMIT = "promo_registration_submit";

/** Step 6 – Submission is created via /finalize endpoint (exact count) */
export const PROMO_SUBMISSION_CREATED = "promo_submission_created";

/** Step 7 – Thank-you page is displayed */
export const PROMO_THANK_YOU_PAGE_VIEW = "promo_thank_you_page_view";

// ─── Additional Tracked Interactions ────────────────────────────────────────

/** Pizza Tracker – user clicks "Details" button on a submission row */
export const PROMO_TRACKER_DETAILS_CLICK = "promo_tracker_details_click";

/** Submission status page viewed */
export const PROMO_SUBMISSION_STATUS_VIEW = "promo_submission_status_view";

/** Custom/partner landing page viewed (AAA, Apple, Google, Ooma, etc.) */
export const PROMO_CUSTOM_LANDING_PAGE_VIEW = "promo_custom_landing_page_view";
